import { useContext } from "react";
import { Divider, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import moment from "moment";
import { LocaleContext } from "../../../routing/LangRouter";

//import utils
import { convertToJalali, formatGregorianDate } from "../../../utils/date";

//import images and icons
import { ArrowLeft2, ArrowRight2 } from "iconsax-react";

//import styles
import "./day-change.scss";

function DayChange({ setRequestFlag, information, isDeparture, label, setUid, date }) {
    //general variables
    const { t } = useTranslation();
    const { locale } = useContext(LocaleContext);
    const { isItinerary } = JSON.parse(sessionStorage.getItem("generalInformation")) || {};
    const hotelInformation = JSON.parse(sessionStorage.getItem("hotelInformation"));

    //handle previous day and next day for flight
    const handleDayChange = type => {
        const { departureDate, returnDate } = information;

        const currentDate = moment().startOf("day");
        const targetDate = isDeparture ? moment(departureDate) : moment(returnDate);
        const otherDate = isDeparture ? moment(returnDate) : moment(departureDate);
        let newDate;

        if (type === "previous") {
            newDate = targetDate.clone().subtract(1, "day");
            if (newDate.isBefore(currentDate)) {
                return toast.error(t("flightMessage2"), { toastId: "custom-id-yes" });
            }
            if (!isDeparture && newDate.isBefore(otherDate)) {
                return toast.error(t("flightMessage3"), { toastId: "custom-id-yes" });
            }
        } else if (type === "next") {
            newDate = targetDate.clone().add(1, "day");
            if (isDeparture && returnDate !== "null" && !!returnDate && newDate.isAfter(otherDate)) {
                return toast.error(t("flightMessage4"), { toastId: "custom-id-yes" });
            }
        }
        if (isDeparture) {
            information.departureDate = newDate.format("YYYY-MM-DD");
        } else {
            information.returnDate = newDate.format("YYYY-MM-DD");
        }
        if (isItinerary) {
            hotelInformation.checkIn = information.departureDate;
            hotelInformation.checkOut = information.returnDate || hotelInformation.checkOut;
            sessionStorage.setItem("hotelInformation", JSON.stringify(hotelInformation));
        }
        setUid(null);
        sessionStorage.setItem(`${label}`, JSON.stringify(information));
        setRequestFlag(true);
    };

    return (
        <Grid
            className="day-change"
            container
            item
            xs="auto"
            columnGap={1}
            justifyContent={{ xs: "space-between", md: "flex-end" }}
            alignItems="center"
        >
            <span onClick={() => handleDayChange("previous")}>
                {locale === "en" ? <ArrowLeft2 color="var(--teal-color-18)" /> : <ArrowRight2 color="var(--teal-color-18)" />} {t("previousDay")}
            </span>
            <Divider orientation="vertical" flexItem sx={{ display: { xs: "none", md: "flex" } }} />
            <Grid className="day-change__date" container item xs="auto" display={{ xs: "flex", md: "none" }}>
                {locale === "fa" ? convertToJalali(date) : formatGregorianDate(date, null, "YYYY/MM/DD")}
            </Grid>
            <span onClick={() => handleDayChange("next")}>
                {t("nextDay")} {locale === "en" ? <ArrowRight2 color="var(--teal-color-18)" /> : <ArrowLeft2 color="var(--teal-color-18)" />}
            </span>
        </Grid>
    );
}

export default DayChange;
